// extracted by mini-css-extract-plugin
export default {"errorInput":"Contact_errorInput__1b6Wy","errorMessage":"Contact_errorMessage__8MtmF","invalid-form-group":"Contact_invalid-form-group__+LXq-"};